import { useToastStore } from './../store';
var actionCreatorSelector = function (t) {
    return t.actionCreators;
};
export var useToastActionCreators = function () {
    var actionCreators = useToastStore(actionCreatorSelector);
    return actionCreators;
};
//# sourceMappingURL=useToastActionCreators.js.map